
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_1fsf7_93",
  "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_1fsf7_93",
  "divider": "awsui_divider_x7peu_1fsf7_98",
  "divider-disabled": "awsui_divider-disabled_x7peu_1fsf7_112",
  "divider-active": "awsui_divider-active_x7peu_1fsf7_115",
  "resizer": "awsui_resizer_x7peu_1fsf7_119",
  "has-focus": "awsui_has-focus_x7peu_1fsf7_176",
  "tracker": "awsui_tracker_x7peu_1fsf7_199"
};
  